/**
 * Bag・Sunglasses専用メニュー機能
 * - モバイル: アコーディオンメニュー（DawnのMenuDrawerと競合しないよう独自制御）
 * - PC: コンパクトメガメニューの画面端自動調整
 */
(function() {
  'use strict';

  /**
   * モバイル用アコーディオンメニューの初期化
   */
  function initCustomAccordions() {
    var customAccordions = document.querySelectorAll(
      '.menu-drawer__bag-accordion, .menu-drawer__sunglasses-accordion'
    );

    customAccordions.forEach(function(accordion) {
      var summary = accordion.querySelector('summary');

      if (!summary) return;

      // MenuDrawerのイベントハンドラより先に実行されるよう、captureフェーズで処理
      summary.addEventListener('click', function(event) {
        // イベントの伝播を停止してMenuDrawerのハンドラが発火しないようにする
        event.stopPropagation();

        // detailsのopen状態を手動でトグル
        var details = summary.parentElement;
        var isOpen = details.hasAttribute('open');

        if (isOpen) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }

        // デフォルトのdetails動作をキャンセル（手動で制御するため）
        event.preventDefault();
      }, true); // capture: true で先に実行
    });
  }

  /**
   * PC用コンパクトメガメニューの画面端自動調整
   */
  function initCompactMegaMenuPositioning() {
    var compactMenus = document.querySelectorAll('.mega-menu--compact');

    compactMenus.forEach(function(menu) {
      var content = menu.querySelector('.mega-menu__content');
      if (!content) return;

      // メニューが開いた時に位置を調整
      menu.addEventListener('toggle', function() {
        if (menu.open) {
          adjustMenuPosition(menu, content);
        }
      });

      // ウィンドウリサイズ時も調整（メニューが開いている場合）
      window.addEventListener('resize', function() {
        if (menu.open) {
          adjustMenuPosition(menu, content);
        }
      });
    });
  }

  /**
   * メニュー位置を調整（画面端で見切れないようにする）
   */
  function adjustMenuPosition(menu, content) {
    // 既存の調整クラスをリセット
    content.classList.remove('adjust-left', 'adjust-right');

    // メニューのサイズと位置を取得
    var menuRect = menu.getBoundingClientRect();
    var contentWidth = content.offsetWidth;
    var viewportWidth = window.innerWidth;

    // メニューの中央位置
    var menuCenterX = menuRect.left + (menuRect.width / 2);

    // コンテンツが中央配置された場合の左端と右端
    var contentLeft = menuCenterX - (contentWidth / 2);
    var contentRight = menuCenterX + (contentWidth / 2);

    // マージン（画面端からの最小距離）
    var margin = 16;

    // 左端がはみ出す場合
    if (contentLeft < margin) {
      content.classList.add('adjust-left');
    }
    // 右端がはみ出す場合
    else if (contentRight > viewportWidth - margin) {
      content.classList.add('adjust-right');
    }
    // どちらもはみ出さない場合は中央配置（デフォルト）
  }

  // DOMContentLoadedで初期化
  function init() {
    initCustomAccordions();
    initCompactMegaMenuPositioning();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
